import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';


class Navigation extends Component {


  render() {

    function handleClick(e) {
      // e.preventDefault();
      document.body.className = document.body.className.replace("navbar-open","");
    }

    return (
      <nav className="navbar navbar-expand-lg" data-navbar="smart">
        <div className="container">
          <div className="navbar-left">
            <button className="navbar-toggler" type="button">&#9776;</button>
            <Link className="navbar-brand" to="/">
              <img src="assets/img/logo/logo.png" alt="logo" width="110"/>
            </Link>
          </div>
          <section className="navbar-mobile">

            <button type="button" className="close position-static px-0 navbar-toggler"  onClick={handleClick}>
              <span aria-hidden="true">×</span>
            </button>

            <nav className="nav nav-navbar mr-auto">
              <li className="nav-item">
                <NavLink className="nav-link" activeClassName="active" to="/"  onClick={handleClick} exact>L'artiste</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" activeClassName="active" to="/Sculpture"  onClick={handleClick}>Galerie d'Art</NavLink>
              </li>
              <li className="nav-item"> 
                <NavLink className="nav-link" activeClassName="active" to="/News"  onClick={handleClick}>Actualités & Dates</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" activeClassName="active" to="/Contact"  onClick={handleClick}>Contact</NavLink>
              </li>
            </nav>
          </section>
        </div>
      </nav>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation.js